var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPromotores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#03324c;stroke-width:22.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:333.3333;}\n\t.st1{fill:none;stroke:#03324c;stroke-width:50;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:133.3333;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.6,347.9l2.9-69.6c4.1-36.6-6.5-66.5-70.5-66.5H235c-64,0-74.5,29.8-70.5,66.5l11.2,120 c3.2,29.4,14,53.5,74.2,53.5h100.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.9,451.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,211.9v-12c0-26.6,0-48,48-48h24c48,0,48,21.4,48,48v12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340,316.9v15c0,0.1,0,0.1,0,0.3c0,16.4-0.2,29.7-30,29.7c-29.7,0-30-13.2-30-29.6v-15.4c0-15,0-15,15-15h30 C340,301.9,340,301.9,340,316.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454.8,286.9c-34.6,25.2-74.2,40.2-114.7,45.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.3,290.9c33.8,23.1,71.9,37,110.7,41.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M439.2,643.1h120c60.3,0,71.1-24.2,74.2-53.5l11.2-120c4-36.6-6.5-66.5-70.5-66.5h-150 c-64.1,0-74.6,29.9-70.5,66.5l11.2,120C368.1,619,378.9,643.1,439.2,643.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M439.2,403.1v-12c0-26.5,0-48,48-48h24c48,0,48,21.5,48,48v12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M529.2,508.1v15c0,0.2,0,0.2,0,0.3c0,16.4-0.2,29.7-30,29.7c-29.7,0-30-13.2-30-29.5v-15.5c0-15,0-15,15-15 h30C529.2,493.1,529.2,493.1,529.2,508.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M644,478.1c-34.6,25.2-74.2,40.2-114.7,45.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.5,482.2c33.8,23.1,71.8,37,110.7,41.4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.6,730.8h200c166.7,0,233.3-66.7,233.3-233.3v-200c0-166.7-66.7-233.3-233.3-233.3h-200 C138,64.2,71.3,130.8,71.3,297.5v200C71.3,664.2,138,730.8,304.6,730.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPromotores);
export default __webpack_public_path__ + "static/media/iconPromotores.5cbfd767099e0ba4bc577820524880a1.svg";
export { ForwardRef as ReactComponent };